/* Location page: default activity filter to "Staff Picks" */
$(document).ready(function() {
    setTimeout(function() {
        $('body.location section.activity ul[data-filter-group="activity"] a').each(function(el) {
            if ($(this).text() === 'Staff Picks') {
                $(this).click();
            }
        });
    }, 500);
});
